import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { VolunteerStatusId } from '@interfaces';
import { DomainDataService } from '../../../../../services';
import { VolunteeringAreaService } from '../../../volunteering-area.service';
import { VolunteeringProspectsService } from '../../volunteering-prospects.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'potential-volunteers-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './potential-volunteers.part.html',
})
export class PotentialVolunteersViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	private readonly areaService = inject(VolunteeringAreaService);
	private readonly pageService = inject(VolunteeringProspectsService);
	private readonly domainDataService = inject(DomainDataService);
	private readonly dialogService = inject(DialogService);

	public setup = getSetup(this.areaService, this.util, this.domainDataService, this.dialogService, this.areaService.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public potentialVolunteers = computed(() =>
		(this.areaService.volunteeringData()?.volunteerProspects || []).filter(v => v.volunteerStatusId === VolunteerStatusId.Pending)
	);

	ngOnInit() {
		this.areaService.getVolunteeringData();
	}

}